import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import React, { useState } from "react";
import { toast } from "./toast/CustomToast";
/**
 *
 * 251204  - 박현민
 * tanstack 라이브러리 추가 + Client Provider 역할분리
 * 전역 에러핸들러 추가
 *

 * 20260108 - 박현민
 * toast 대신 CustomToast 컴포넌트 생성 ( 컴파운드 패턴 )
 */

export function ReactQueryClientProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const toToastMessage = (value: unknown): string => {
    if (typeof value === "string") return value;
    if (value == null) return "요청 처리 중 오류가 발생했습니다.";
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  };

  const queryErrorHandler = (err: Error) => {
    // HTML 응답 등 skipToast 플래그가 있는 경우 toast 표시 안 함
    if ((err as { skipToast?: boolean }).skipToast) {
      return;
    }
    toast.error(toToastMessage((err as { message?: unknown }).message), {
      duration: 2000,
    });
  };

  const [queryClient] = useState(
    () =>
      new QueryClient({
        queryCache: new QueryCache({
          onError: queryErrorHandler,
        }),
        mutationCache: new MutationCache({
          onError: queryErrorHandler,
        }),
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
